/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as TeamDefs from '../team/defs.defs.js'

const $nsid = 'tools.ozone.queue.defs'

type $nsid = typeof $nsid

export { $nsid }

type QueueView = {
  $type?: 'tools.ozone.queue.defs#queueView'

  /**
   * Queue ID
   */
  id: number

  /**
   * Display name of the queue
   */
  name: string

  /**
   * Subject types this queue accepts.
   */
  subjectTypes?: (
    'account' | 'record' | 'message' | 'conversation' | l.UnknownString
  )[]

  /**
   * Collection name for record subjects (e.g., 'app.bsky.feed.post')
   */
  collection?: l.NsidString

  /**
   * Report reason types this queue accepts (fully qualified NSIDs)
   */
  reportTypes?: string[]

  /**
   * Optional description of the queue
   */
  description?: string

  /**
   * Policy keys recommended when actioning reports in this queue
   */
  recommendedPolicies?: string[]

  /**
   * DID of moderator who created this queue
   */
  createdBy: l.DidString
  createdAt: l.DatetimeString
  updatedAt: l.DatetimeString

  /**
   * Whether this queue is currently active
   */
  enabled: boolean

  /**
   * When the queue was deleted, if applicable
   */
  deletedAt?: l.DatetimeString

  /**
   * Statistics about this queue
   */
  stats: QueueStats
}

export type { QueueView }

const queueView = /*#__PURE__*/ l.typedObject<QueueView>(
  $nsid,
  'queueView',
  /*#__PURE__*/ l.object({
    id: /*#__PURE__*/ l.integer(),
    name: /*#__PURE__*/ l.string(),
    subjectTypes: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.string<{
          knownValues: ['account', 'record', 'message', 'conversation']
        }>(),
      ),
    ),
    collection: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'nsid' }),
    ),
    reportTypes: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(/*#__PURE__*/ l.string()),
    ),
    description: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    recommendedPolicies: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(/*#__PURE__*/ l.string()),
    ),
    createdBy: /*#__PURE__*/ l.string({ format: 'did' }),
    createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    updatedAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    enabled: /*#__PURE__*/ l.boolean(),
    deletedAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    stats: /*#__PURE__*/ l.ref<QueueStats>((() => queueStats) as any),
  }),
)

export { queueView }

type QueueStats = {
  $type?: 'tools.ozone.queue.defs#queueStats'

  /**
   * Number of reports in 'open' status
   */
  pendingCount?: number

  /**
   * Number of reports in 'closed' status
   */
  actionedCount?: number

  /**
   * Number of reports in 'escalated' status
   */
  escalatedCount?: number

  /**
   * Reports received in this queue in the last 24 hours.
   */
  inboundCount?: number

  /**
   * Percentage of reports actioned (actionedCount / inboundCount * 100), rounded to nearest integer. Absent when inboundCount is 0.
   */
  actionRate?: number

  /**
   * Average time in seconds from report creation to close, for reports closed in this period.
   */
  avgHandlingTimeSec?: number

  /**
   * When these statistics were last computed
   */
  lastUpdated?: l.DatetimeString
}

export type { QueueStats }

const queueStats = /*#__PURE__*/ l.typedObject<QueueStats>(
  $nsid,
  'queueStats',
  /*#__PURE__*/ l.object({
    pendingCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    actionedCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    escalatedCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    inboundCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    actionRate: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    avgHandlingTimeSec: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    lastUpdated: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
  }),
)

export { queueStats }

type AssignmentView = {
  $type?: 'tools.ozone.queue.defs#assignmentView'
  id: number
  did: l.DidString

  /**
   * The moderator assigned to this queue
   */
  moderator?: TeamDefs.Member
  queue: QueueView
  startAt: l.DatetimeString
  endAt?: l.DatetimeString
}

export type { AssignmentView }

const assignmentView = /*#__PURE__*/ l.typedObject<AssignmentView>(
  $nsid,
  'assignmentView',
  /*#__PURE__*/ l.object({
    id: /*#__PURE__*/ l.integer(),
    did: /*#__PURE__*/ l.string({ format: 'did' }),
    moderator: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<TeamDefs.Member>((() => TeamDefs.member) as any),
    ),
    queue: /*#__PURE__*/ l.ref<QueueView>((() => queueView) as any),
    startAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    endAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
  }),
)

export { assignmentView }
